import { type ImageElement } from '../plugins/image';
import { type ElementMap } from '../stores/useEditorStore';

export const strokeRectWithRotation = (
  context: CanvasRenderingContext2D,
  x: number,
  y: number,
  width: number,
  height: number,
  cx: number,
  cy: number,
  angle: number,
  fill = false,
  radius = 0,
) => {
  context.save();
  context.translate(cx, cy);
  context.rotate(angle);
  if (fill) {
    context.fillRect(x - cx, y - cy, width, height);
  }
  if (radius && context.roundRect) {
    context.beginPath();
    context.roundRect(x - cx, y - cy, width, height, radius);
    context.stroke();
    context.closePath();
  } else {
    context.strokeRect(x - cx, y - cy, width, height);
  }
  context.restore();
};

export const fillCircle = (
  context: CanvasRenderingContext2D,
  cx: number,
  cy: number,
  radius: number,
  stroke = true,
) => {
  context.beginPath();
  context.arc(cx, cy, radius, 0, Math.PI * 2);
  context.fill();
  if (stroke) {
    context.stroke();
  }
};

export const fillRoundRect = (
  context: CanvasRenderingContext2D,
  x: number,
  y: number,
  width: number,
  height: number,
  radius = 0,
  stroke = true,
) => {
  context.beginPath();
  context.roundRect(x, y, width, height, radius);
  context.fill();
  if (stroke) {
    context.stroke();
  }
};

export const createCanvas = (size?: { width?: number; height?: number }) => {
  const canvas = document.createElement('canvas');
  if (size?.width) canvas.width = size.width;
  if (size?.height) canvas.height = size.height;

  return canvas;
};

export const clipToMainImage = (
  context: CanvasRenderingContext2D,
  elements: ElementMap,
  element: { x: number; y: number },
  offset = 0,
) => {
  let mainImage: ImageElement | null = null;

  for (const e of elements.values()) {
    if (e.type === 'image' && e.layer === 0) {
      mainImage = e as ImageElement;
      break;
    }
  }

  if (mainImage) {
    const imagePath = new Path2D();
    imagePath.rect(
      mainImage.x - element.x + offset,
      mainImage.y - element.y + offset,
      mainImage.width,
      mainImage.height,
    );
    context.clip(imagePath);
  }
};
